<template>
  <div :class="inlinerows == 'true' ? inlinerowclasses + ' row' : inlinerowclasses">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? inlineLabelClass + ' col-form-label' : 'form-label'">{{ label }}<span v-if="required" style="color: red">*</span></label>
    <div :class="inlinerows == 'true' ? inlineInputClass : label ? '' : 'col-md-12'">
      <slot> </slot>
      <small class="input-error" v-if="error">{{ error }}</small>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/form-group.scss";
export default {
  name: "input-holder",
  data() {
    return {};
  },
  methods: {},
  props: {
    label: {
      type: String,
      default: "",
    },
    inlinerows: {
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
    inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    required: {
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
  },
};
</script>
